import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

export default function Login() {
  const location = useLocation();
  const navigate = useNavigate();
  const error = location.state?.error;

  useEffect(() => {
    if (error) return;
    api.get("/auth/me").then(() => navigate("/admin", { replace: true })).catch(() => {});
  }, [error, navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-sand grid place-items-center px-5 font-admin notranslate" translate="no">
      <div className="w-full max-w-sm bg-white rounded-3xl border border-border p-8 text-center space-y-6" data-testid="login-card">
        <img src="/logo.png" alt="Indo Aura Dive" className="w-32 h-32 mx-auto object-contain" />
        <div>
          <h1 className="text-2xl font-extrabold">Admin dashboard</h1>
          <p className="text-slate-500 text-sm mt-1">Only approved Google accounts can sign in.</p>
        </div>
        {error && <p className="text-sm bg-rose-50 text-rose-700 rounded-xl p-3" data-testid="login-error">{error}</p>}
        <button onClick={signIn} data-testid="google-login-btn"
          className="w-full h-14 rounded-2xl bg-ink text-white font-semibold flex items-center justify-center gap-3 hover:bg-slate-800 transition-colors duration-200">
          <ShieldCheck className="w-5 h-5" /> Sign in with Google
        </button>
        <a href="/" className="block text-sm text-slate-500 hover:text-ink" data-testid="back-to-site-link">← Back to website</a>
      </div>
    </div>
  );
}
